import { Component, OnInit } from "@angular/core";
import { ChartConfiguration, ChartOptions } from "chart.js";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { IndicatorService } from "src/app/ui/services/pbm/indicator.service";
import { CompanySubsidiaryBalanceIndicatorData } from "src/app/ui/models/domains/pbm/indicators/company-subsidiary-balance-data";
import { IndicatorMediator } from "src/app/ui/services/pbm/indicator-mediator";
import { CompanySubsidiaryMonthlyBalanceIndicatorDataStrategy } from "src/app/ui/pages/home/indicator-data-strategies";

@Component({
  selector: "company-subsidiary-balance",
  templateUrl: "./company-subsidiary-balance.component.html",
  styleUrls: ["./company-subsidiary-balance.component.scss"],
})
export class CompanySubsidiaryBalanceComponent implements OnInit {
  public companyName: string;
lineChartData: ChartConfiguration<"line">["data"]; // tipo alterado para 'line'
public lineChartLabels: string[] = [""]; // mantenha suas labels aqui

public lineChartOptions: ChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      ticks: {
        color: "#090f34",
        autoSkip: true,
        maxRotation: 0,
        minRotation: 0,
      },
    },
    y: {
      beginAtZero: true,
      position: "left",
      min: 0,
      ticks: {
        padding: 25,
        stepSize: 300000,
        color: "#090f34",
        font: {
          size: 11,
        },
      },
    },
  },
  plugins: {
    legend: {
      display: true,
      labels: {
        color: "#090f34",
        padding: 10,
      },
    },
    datalabels: {
      display: false // <<< remove os valores dos pontos
    },
  },
};
  public isLoading: boolean = true;

  constructor(private indicatorService: IndicatorService, private indicatorMediator: IndicatorMediator) {}

  async ngOnInit() {
    const companySubsidiaryBalanceIndicatorData = (await this.indicatorMediator.getIndicatorData(
      new CompanySubsidiaryMonthlyBalanceIndicatorDataStrategy(),
    )) as CompanySubsidiaryBalanceIndicatorData;
    this.companyName = companySubsidiaryBalanceIndicatorData.getCompanyName();
    this.setMonths(companySubsidiaryBalanceIndicatorData.getMonths());
    this.setChartData(companySubsidiaryBalanceIndicatorData);
    this.isLoading = false;
  }

  public async onFilterData(company: Company) {
    this.isLoading = true;
    if (company) await this.buildChart([company.getFiscalNumber()]);
    else {
      this.lineChartData = {
        labels: this.lineChartLabels,
        datasets: [],
      };
    }
    this.isLoading = false;
  }

  public setMonths(months: Array<string>): void {
    this.lineChartLabels = months;
  }

  public async buildChart(fiscalNumber: Array<string>): Promise<void> {
    const companySubsidiaryBalanceIndicatorData = await this.indicatorService.getCompanySubsidiaryMonthlyBalance(fiscalNumber);
    this.setMonths(companySubsidiaryBalanceIndicatorData.getMonths());
    this.setChartData(companySubsidiaryBalanceIndicatorData);
  }

  public async setChartData(monthlyBalanceData: CompanySubsidiaryBalanceIndicatorData): Promise<void> {
    let barChartData = [];
    const subsidiaryNames = monthlyBalanceData.getSubsidiaryNames();
    if (subsidiaryNames.length > 0) {
      const subsidiaryBarData = new Array<any>();
      subsidiaryNames.forEach((subsidiaryName) => {
        const subsidiaryValues = monthlyBalanceData.getSubsidiaryValues(subsidiaryName);
        subsidiaryBarData.push({
          data: subsidiaryValues,
          label: subsidiaryName,
        });
      });
      barChartData = subsidiaryBarData;
    }
    this.lineChartData = {
      labels: this.lineChartLabels,
      datasets: barChartData,
    };
  }

  public hasCompanySubsidiaryBalanceData(): boolean {
    return !!this.lineChartData && !!this.lineChartData.datasets && !!this.lineChartData.datasets.length;
  }
}
